import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromAzureBlobStorage from './reducers/azure-blob-storage.reducer';
import { EffectsModule } from '@ngrx/effects';
import { AzureBlobStorageEffects } from './effects/azure-blob-storage.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('azureBlobStorage', fromAzureBlobStorage.reducer),
    StoreModule.forFeature('sasToken', fromAzureBlobStorage.tokenReducer),
    EffectsModule.forFeature([AzureBlobStorageEffects])
  ]
})
export class AzureBlobStorageModule { }
